import React from 'react';
import { Route } from 'react-router-dom';
import { APP_ROUTES } from '../../../../../shared/config/routes-config';
import { MainCalendar } from './MainCalendar';
export const CalendarModule = () => (
  <Route exact path={APP_ROUTES.CALENDAR_MODULE.PATH} component={MainCalendar} />
);
